const getQueryErrorInvalidLoginOrPassword = () => {
  return "Неверный логин или пароль";
};

export default getQueryErrorInvalidLoginOrPassword;
